import React, { useEffect, useState } from "react";
import SimpleArtist from "components/artists/SimpleArtist";
import { useNavigate } from "react-router-dom";
import { ApiService } from "services/ApiService";

const AdminPage: React.FC = () => {
    const [activeComponent, setActiveComponent] = useState<string>("createArtist");
    const [hasAccess, setHasAccess] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAccess = async () => {
            try {
                const response = await ApiService.checkAdminAccess();

                if (response.success) {
                    setHasAccess(true);
                }
                else{
                    setHasAccess(false);
                }

            } catch (error) {
                console.error("Error checking admin access:", error);
                setHasAccess(false);
            }
        };
        checkAccess();
    }, []);

    if (hasAccess === null) {
        // Show a loading state while checking access
        return <div className="flex items-center justify-center h-screen">Loading...</div>;
    }

    if (!hasAccess) {
        // Redirect or show an error message if the user doesn't have access
        navigate("/unauthorized"); // Redirect to an unauthorized page
        return null;
    }


    const renderComponent = () => {
        switch (activeComponent) {
            case "createArtist":
                return <SimpleArtist />;
            case "userSearch":
                return <div className="p-6">User Search Component Placeholder</div>;
            default:
                return <div className="p-6">Select an option from the menu</div>;
        }
    };

    return (
        <div className="flex h-screen">
            {/* Left Sidebar */}
            <div className="w-1/4 bg-gray-100 p-4 shadow-md">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Admin Panel</h2>
                <ul className="space-y-2">
                    <li>
                        <button
                            onClick={() => setActiveComponent("createArtist")}
                            className={`w-full text-left px-4 py-2 rounded-md ${
                                activeComponent === "createArtist"
                                    ? "bg-indigo-600 text-white"
                                    : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                            }`}
                        >
                            Create Artist
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => setActiveComponent("userSearch")}
                            className={`w-full text-left px-4 py-2 rounded-md ${
                                activeComponent === "userSearch"
                                    ? "bg-indigo-600 text-white"
                                    : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                            }`}
                        >
                            User Search
                        </button>
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="flex-grow bg-white p-6">
                {renderComponent()}
            </div>
        </div>
    );
};

export default AdminPage;